import React from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '../components/PageLayout';

// Course review data
const courseReviews = [
  {
    id: 1,
    slug: 'the-crossvines-family-tradition',
    title: 'The Crossvines: A Family Tradition for Over a Decade',
    date: 'April 19, 2025',
    image: 'https://images.pexels.com/photos/7242696/pexels-photo-7242696.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    excerpt: '"My grandson Colin and I have been playing this beautiful course every week for over 10 years. The staff knows us by name, and watching him grow from a beginner to nearly beating his grandfather has been the joy of my life. The course\'s varied terrain and excellent maintenance make each round a new adventure, even after hundreds of visits."',
    author: 'Bob Cope',
    authorTitle: 'Member since 2015',
    content: `
      <p>"My grandson Colin and I have been playing this beautiful course every week for over 10 years. The staff knows us by name, and watching him grow from a beginner to nearly beating his grandfather has been the joy of my life. The course's varied terrain and excellent maintenance make each round a new adventure, even after hundreds of visits."</p>
      
      <h2>A Special Bond Formed on the Fairways</h2>
      
      <p>What began as simple golf lessons for my 12-year-old grandson has evolved into a cherished weekly tradition that's spanned more than a decade. Through high school championships, college applications, and now his early career, our Saturday morning tee time at The Crossvines has remained sacred.</p>
      
      <p>"The course has become our second home," says Colin, now 22 and an accomplished golfer in his own right. "Some of my most important life conversations with my grandfather happened walking down these fairways."</p>
      
      <h2>Course Highlights</h2>
      
      <p>The Crossvines offers nearly 7,000 yards of championship golf across 380 beautiful acres in Maryland's Potomac Valley. The front nine features more open play with strategic bunkering, while the back nine winds through mature woodlands with elevation changes that challenge shot selection.</p>
      
      <ul>
        <li><strong>Signature Hole</strong>: The par-3 12th requires a precise tee shot over water to a well-protected green</li>
        <li><strong>Most Challenging</strong>: The dogleg par-4 7th demands both length and accuracy</li>
        <li><strong>Hidden Gem</strong>: The par-5 15th offers risk/reward opportunities for big hitters</li>
      </ul>
      
      <h2>Beyond the Course</h2>
      
      <p>What sets The Crossvines apart isn't just the quality of golf but the complete experience. The clubhouse features The Farmhouse Bistro, serving exceptional farm-to-table cuisine. The unique wine tasting facility adds another dimension to post-round relaxation.</p>
      
      <p>"After our round, Colin and I usually enjoy lunch on the patio overlooking the 18th green," Bob explains. "We've celebrated birthdays, graduations, and even Colin's job offers at this very spot."</p>
      
      <h2>Final Thoughts</h2>
      
      <p>For anyone looking to create lasting memories with family while enjoying a top-quality golf experience, The Crossvines offers the perfect setting. The course's combination of challenging play, beautiful scenery, and welcoming atmosphere has created the backdrop for our family's most cherished traditions.</p>
      
      <p>As Bob likes to say, "Golf is just the excuse - it's really about the time together. And there's no better place for that than The Crossvines."</p>
    `
  },
  {
    id: 2,
    slug: 'st-andrews-links-footsteps-of-champions',
    title: 'St. Andrews Links: Walking in the Footsteps of Champions',
    date: 'April 18, 2025',
    image: 'https://images.pexels.com/photos/914682/pexels-photo-914682.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    excerpt: 'Our expert review of the historic St. Andrews Links, including detailed hole-by-hole analysis and tips for first-time visitors.',
    author: 'Tom Richards',
    authorTitle: 'Golf Historian',
    content: `
      <p>There are golf courses, and then there is St. Andrews Links - the birthplace of the game and a pilgrimage destination for golfers worldwide. Walking the hallowed fairways of the Old Course is a transcendent experience that connects you to over 600 years of golfing history.</p>
      
      <h2>The Old Course Experience</h2>
      
      <p>From the iconic Swilcan Bridge to the massive double greens and the notorious Hell Bunker, every step at St. Andrews feels significant. The course layout, largely unchanged for centuries, reminds us that the best designs work with the natural landscape rather than against it.</p>
      
      <p>The key to scoring well here isn't power but strategy and imagination. The open fairways can seem generous, but proper positioning is essential for approaching the large, undulating greens. Local knowledge is invaluable, making a caddie a worthwhile investment for first-time visitors.</p>
      
      <h2>Beyond the Old Course</h2>
      
      <p>While the Old Course rightfully captures the imagination, St. Andrews offers six additional courses worth exploring:</p>
      
      <ul>
        <li><strong>The New Course</strong>: Despite its name, it dates to 1895 and offers a more conventional layout</li>
        <li><strong>The Castle Course</strong>: The newest addition, featuring dramatic clifftop holes with stunning sea views</li>
        <li><strong>Jubilee, Eden, and Strathtyrum</strong>: Each with its own character and challenges</li>
      </ul>
      
      <h2>Tips for First-Time Visitors</h2>
      
      <p>Securing a tee time on the Old Course requires planning. The advance application process opens roughly a year ahead, but there's also a daily ballot for next-day tee times, and single golfers can often join with other groups through the starter.</p>
      
      <p>Beyond golf, the St. Andrews experience includes:</p>
      
      <ul>
        <li>Touring the British Golf Museum</li>
        <li>Walking the historic town with its university buildings and cathedral ruins</li>
        <li>Enjoying a post-round drink at the famous Jigger Inn</li>
      </ul>
      
      <p>For the complete experience, stay at the Old Course Hotel or one of the historic inns in town, allowing you to fully immerse yourself in the atmosphere of this special place.</p>
    `
  },
  {
    id: 3,
    slug: 'pine-valley-americas-greatest-test',
    title: 'Pine Valley Golf Club: America\'s Greatest Test',
    date: 'April 11, 2025',
    image: 'https://images.pexels.com/photos/6859552/pexels-photo-6859552.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    excerpt: 'Discover what makes Pine Valley consistently rank as one of the world\'s top courses, with insights into its unique challenges and stunning design.',
    author: 'Lisa Chen',
    authorTitle: 'Golf Architecture Expert',
    content: `<p>Content coming soon</p>`
  },
  {
    id: 4,
    slug: 'mountain-view-golfing-in-the-clouds',
    title: 'Mountain View Golf Resort: Golfing in the Clouds',
    date: 'April 4, 2025',
    image: 'https://images.pexels.com/photos/1473050/pexels-photo-1473050.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    excerpt: 'Our comprehensive review of Mountain View\'s challenging layout, spectacular views, and world-class amenities.',
    author: 'Robert Taylor',
    authorTitle: 'Travel Golf Writer',
    content: `<p>Content coming soon</p>`
  }
];

/**
 * Course Reviews page component
 */
const CourseReviewsPage: React.FC = () => {
  return (
    <PageLayout 
      title="Course Reviews" 
      subtitle="In-depth reviews of top golf courses from our experts"
      backgroundImage="https://images.pexels.com/photos/6573288/pexels-photo-6573288.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
    >
      <section>
        <h2>Featured Course Reviews</h2>
        <div className="blog-posts">
          {courseReviews.map(review => (
            <div key={review.id} className="blog-post-card">
              <div 
                className="blog-post-image"
                style={{ backgroundImage: `url(${review.image})` }}
              ></div>
              <div className="blog-post-content">
                <div className="blog-post-date">{review.date} | By {review.author}</div>
                <h3 className="blog-post-title">{review.title}</h3>
                <p className="blog-post-excerpt">{review.excerpt}</p>
                <Link to={`/course-reviews/${review.slug}`} className="blog-post-link">
                  Read Full Review →
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>
      
      <section>
        <h2>Course Rating Guide</h2>
        <div className="content-card">
          <p>Our expert reviews rate courses on the following criteria:</p>
          <ul>
            <li><strong>Course Design & Layout</strong> - Creativity, challenge, variety, and flow</li>
            <li><strong>Course Conditions</strong> - Turf quality, maintenance, and consistency</li>
            <li><strong>Scenery & Setting</strong> - Natural beauty and visual appeal</li>
            <li><strong>Facilities & Amenities</strong> - Clubhouse, practice areas, dining options</li>
            <li><strong>Value & Accessibility</strong> - Price relative to experience, tee time availability</li>
          </ul>
          <p>Each category is scored from 1-10, with a maximum overall rating of 5 stars.</p>
        </div>
      </section>
      
      <section>
        <h2>Submit Your Review</h2>
        <p>Have you played a course that we've reviewed? We'd love to hear about your experience!</p>
        <form className="contact-form">
          <div className="form-group">
            <label htmlFor="courseName">Course Name</label>
            <input type="text" id="courseName" placeholder="Enter course name" />
          </div>
          
          <div className="form-group">
            <label htmlFor="dateVisited">Date Played</label>
            <input type="date" id="dateVisited" />
          </div>
          
          <div className="form-group">
            <label htmlFor="rating">Your Rating (1-5)</label>
            <select id="rating">
              <option value="">Select rating</option>
              <option value="5">5 - Exceptional</option>
              <option value="4">4 - Excellent</option>
              <option value="3">3 - Good</option>
              <option value="2">2 - Fair</option>
              <option value="1">1 - Poor</option>
            </select>
          </div>
          
          <div className="form-group">
            <label htmlFor="reviewComments">Your Review</label>
            <textarea id="reviewComments" rows={6} placeholder="Share your experience"></textarea>
          </div>
          
          <button type="submit" className="form-submit">Submit Review</button>
        </form>
      </section>
    </PageLayout>
  );
};

export default CourseReviewsPage;
